import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner'

class AuthCheck extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let auth_object      = this.props.user && this.props.user.auth ? this.props.user.auth : null;
    let is_authenticated = auth_object && auth_object.token ? true : false;

    if (!is_authenticated && this.props.userActions) {
      this.props.userActions.signOut();
    }
  }

  render() {
    return null;
  }

}

export default AuthCheck
